<template>
    <!-- 帖子 list 的单个,行内样式已经设定了单个 list 的高度-->
    <div class="f-list-post"
        :style="{width:listWidth, height: listHeight}">
        <div class="f-list-topic" @click="toTopicContent">
            <div class="f-list-topic-cont">
                <span class="f-list-topic-title"
                    @click.right.prevent="showMenu"
                    ref="menu">
                    {{list.title}}
                </span>
            </div>

            <!-- 自定义右键菜单，比如右键 title-->
            <vue-context-menu class="right-menu"
                :target="contextMenuTarget"
                :show="contextMenuVisible"
                @update:show="show => contextMenuVisible = show">
                <a @click.stop="toTopicContent">在新标签页中打开链接</a>
                <a @click.stop="toTopicContent">在新窗口中打开链接</a>
                <a @click.stop="copyUrl">复制链接地址</a>
                <a @click.stop="copyTitle">复制</a>
            </vue-context-menu>
            <div>
                <div class="f-list-official-show" v-if="isShowQaOfficialInfo">
                    <div class="f-list-official-show-process"
                        v-show="list.ext.qaOfficialInfo.process">
                        <span>处理状态：</span>
                        <span class="f-list-official-show-bold">
                            {{matchOfficialProcess}}
                        </span>
                    </div>
                    <div class="f-list-official-show-follower"
                        v-if="list.ext.qaOfficialInfo.followUserInfo">
                        <span>跟进人：</span>
                        <img v-show="list.ext.qaOfficialInfo.followUserInfo.avatar"
                            :src="list.ext.qaOfficialInfo.followUserInfo.avatar"
                            class="f-list-official-show-follower-avatar">
                        <span class="f-list-official-show-follower-name f-list-official-show-bold">
                            {{followUserName}}
                        </span>
                        <span class="f-list-official-show-follower-name f-list-official-show-bold">联盟宿主:</span>
                        <span class="f-list-official-show-follower-name f-list-official-show-bold">{{list.userInfo.nickname}}</span>
                    </div>
                </div>
                <state-icon v-else :postState="list.process" class="f-list-state-show"></state-icon>
            </div>

            <div class="f-list-reply">
                <div v-if="isShowTag && list.tagInfo.name.length" class="f-list-reply-tag">
                    <span>{{list.tagInfo.name}}</span>
                    <span class="f-list-reply-tag-border">|</span>
                </div>
                <div class="f-list-reply-user" v-if="Object.keys(list.lastOperationUser).length">
                    <nick-name class="f-list-reply-user-name"
                        :user-info="list.lastOperationUser">
                    </nick-name>
                    <img v-if="list.lastOperationUser.isOfficial" class="f-list-reply-user-icon" :src="verity">
                    <span class="f-list-reply-time">
                        {{lastOperationType}}{{list.lastOperationTime}}
                    </span>
                </div>
                <div class="f-list-reply-message">
                    <commit-icon class="f-list-reply-message-comment" :commitnumber="list.replyCount"></commit-icon>
                </div>
            </div>
        </div>

        <!-- 系统管理员才有的管理权限 -->
        <manager-operation
            v-if="hasSystemPermission"
            class="f-list-topic-official"
            :topicid="list.topicId"
            @refreshlist="refreshList">
        </manager-operation>
    </div>
</template>

<style lang="less">
    @import '../../assets/less/components/context-menu.less';
    @import '../../assets/less/views/topicList.less';
</style>

<script>
/* globals swan */
import CommitIcon from '../../components/Commit.vue';
import ManagerOperation from '../../components/ui-icon/manager-operation';
import NickName from '../../components/NickName';
import {component as VueContextMenu} from '@xunlei/vue-context-menu';
import PostState from '../../components/PostState.vue';

import {mapGetters, mapState} from 'vuex';
import {openNewWindow} from '@/utils/decorate/event';
import {officialProcessMap} from '../../store/common/state/utils/constants';

export default {
    props: {
        listWidth: {
            'type': String,
            'default': ''
        },
        list: {
            'type': Object,
            'default': {}
        },
        isShowTag: {
            'type': Boolean,
            'default': false
        },
        isShowExt: {
            'type': Boolean,
            'default': false
        }
    },
    components: {
        'commit-icon': CommitIcon,
        'manager-operation': ManagerOperation,
        'nick-name': NickName,
        'vue-context-menu': VueContextMenu,
        'state-icon': PostState
    },
    data() {
        return {
            verity: require('../../assets/images/icon-official.png'),
            contextMenuTarget: this.$refs.menu,
            contextMenuVisible: false
        };
    },
    computed: {
        ...mapGetters([
            'hasSystemPermission'
        ]),
        ...mapState({
            routeTarget: state => state.common.routeTarget,
            webPages: state => state.common.webPages,
        }),
        matchOfficialProcess() {
            return officialProcessMap[this.list.process];
        },
        lastOperationType: {
            get() {
                let operation = this.list.topicType === 2 ? '回答于' : '回复于';
                return this.list.lastOperationType === 'CREATE' ? '发布于' : operation;
            }
        },
        isShowQaOfficialInfo() {
            return this.isShowExt
                    && this.list.ext
                    && this.list.ext.qaOfficialInfo;
        },
        listHeight: {
            get() {
                return this.isShowExt ? '110px' : '85px';
            }
        },
        followUserName: {
            get() {
                return this.list.ext.qaOfficialInfo.followUserInfo.nickname
                    ? this.list.ext.qaOfficialInfo.followUserInfo.nickname
                    : '无';
            }
        }
    },
    methods: {
        refreshList() {
            this.$emit('refreshList');
        },
        // 跳转至帖子页面
        toTopicContent() {
            let topicId = this.list.topicId;
            openNewWindow(`${this.webPages.topicContent}/${topicId}`, this.routeTarget);
        },

        /**
         * 展示模拟浏览器的右键菜单
         *
         * @param {object} e 目标对象
         */
        showMenu(e) {
            this.contextMenuVisible = true;
            const {target, offsetX, offsetY, clientY} = e;
            let clickEvent = target.parentNode.nextElementSibling;
            clickEvent.style.left = offsetX + 'px';
            clickEvent.style.top = clientY + 112 <= window.innerHeight
                ? offsetY + 20 + 'px'
                : (window.innerWidth < 1282 && window.innerWidth > 768
                    ? offsetY - clientY + window.innerHeight - 110 + 'px'
                    : offsetY - clientY + window.innerHeight - 92 + 'px');
        },

        /**
         * 隐藏模拟浏览器的右键菜单
         */
        hideMenu() {
            this.contextMenuVisible = false;
        },

        /**
         * 复制跳转链接
         */
        copyUrl() {
            this.hideMenu();
            this.$copyText(`${this.origin}${this.webPages.topicContent}/${this.list.topicId}`);
        },

        /**
         * 复制当前标题文案
         */
        copyTitle() {
            this.hideMenu();
            this.$copyText(this.list.title);
        }

    }
};
</script>
